import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Stack, Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

import { setToken } from '../../../../services/redux-actions';

import { Logo } from '../../../../components-core/landing/Logo';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(setToken(null));
    navigate('/');
  };

  return (
    <header>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Logo />
        <Button variant="contained" endIcon={<LogoutIcon />} onClick={handleLogout}>wyloguj</Button>
      </Stack>
    </header>
  );
};

export default Header;
